<template>
	<div class="col-md-12 col-sm-12 col-xs-12" style="padding-bottom: 50px;">
		<div v-show="loaded">
			<div class="row">
				<div class="form-header">
					<p>{{ tips }}</p>
				</div>
			</div>
			<div class="company-account">
				<trans-account-row v-for="(item, index) in accountList"
													 :key="item.bank_account" :item="item"
													 :last="index == accountList.length - 1"
													 @selected-from-help="handleAccountSelected"
				>
				</trans-account-row>
			</div>
		</div>

		<mt-actionsheet v-model="sheetVisible" :actions="actions" />
	</div>
</template>

<script>
import TransAccountRow from '@/components/TransAccountRow'
import { mapGetters } from 'vuex'

export default {
	name: 'TransAccounts',
	data: () => ({
		'loaded': false,
		'showSummary': false,
		'tips': null,
		accountUserChosen: {
			bankAddress: "",
			accountPretty: ""
		},
		sheetVisible: false,
		actions: []
	}),
	computed: {
		...mapGetters({
			role: 'getRole',
			order: 'getOrder',
			accountList: 'getAccounts'
		}),
		isCustomer () {
			return this.role === 'customer'
		}
	},
	components: {
		TransAccountRow
	},
	created: function () {
		if (this.$route.name === 'TransAccountsHelp') {
			this.tips = '我司收款账号清单'
			this.setPageTitle('我司收款账号')
		} else {
			this.tips = '请先选择您转账到的公司账号'
			this.setPageTitle('查账信息登记')
		}
	},
	mounted: function () {
		this.$store.dispatch('clearPayment', {})
		this.$store.dispatch('clearSelectedPayway', {})
		this.showSummary = this.order.paid_price > 0
		if (this.accountList.length === 0) {
			this.loadAccounts()
		} else {
			this.loaded = true
		}
	},
	methods: {
		loadAccounts () {
			this.loading('正在读取...')
			this.$http.get('/api/integration/trans/accounts').then(response => {
				console.log(response)
				this.loadingHide()
				var rs = response.body
				if (rs.code === 0) {
					this.$store.dispatch('setTxAccountList', {'items': rs.data})
					this.loaded = true
				} else {
					this.handleHttpError(response)
				}
			}, response => {
				console.log(response)
				this.handleHttpError(response)
			})
		},
		handleAccountSelected(item) {
			this.accountUserChosen = item
			this.actions = [
				{
					name: '复制账户名',
					method: () => {
						this.copyTextIntoClipboard(this.accountUserChosen.bankAddress)
					}
				},
				{
					name: '复制账户号',
					method: () => {
						this.copyTextIntoClipboard(this.accountUserChosen.accountPretty)
					}
				}
			]
			this.sheetVisible = true
			// 由于 v-deep 的方式无法生效 因此需要直接控制样式
			this.$nextTick(() => {
				// 找到 ActionSheet 元素（在 body 下）
				const actionsheet = document.querySelector('.mint-actionsheet')
				const list = document.querySelector('.mint-actionsheet-list')
				const items = document.querySelectorAll('.mint-actionsheet-listitem')
				const button = document.querySelector('.mint-actionsheet-button')

				// actionSheet 整体
				if (actionsheet) {
					actionsheet.style.background = 'transparent'
					actionsheet.style.padding = '0 10px 16px'
				}

				// actionSheet 列表整体
				if (list) {
					list.style.borderRadius = '8px'
					list.style.overflow = 'hidden'
				}

				// actionSheet 列表内的每个按钮
				items.forEach((item) => {
					item.style.height = '60px'
					item.style.lineHeight = '60px'
					item.style.textAlign = 'center'
					item.style.fontSize = '16px'
				})

				// actionSheet 取消按钮
				if (button) {
					button.style.height = '60px'
					button.style.lineHeight = '60px'
					button.style.textAlign = 'center'
					button.style.fontSize = '16px'
					button.style.borderRadius = '8px'
				}
			})
		},
		copyTextIntoClipboard(text) {
			if (navigator.clipboard && window.isSecureContext) {
				navigator.clipboard.writeText(text).then(() => {
					this.toast({
						message: '已复制',
						className: 'radius-toast'
					});
				}).catch(() => {
					this.fallbackCopyText(text);
				});
			} else {
				this.fallbackCopyText(text);
			}
		},

		fallbackCopyText(text) {
			const textarea = document.createElement('textarea');

			// 设置样式，防止影响页面布局和用户体验
			textarea.value = text;
			textarea.style.position = 'fixed';
			textarea.style.top = '0';
			textarea.style.left = '0';
			textarea.style.width = '2em';
			textarea.style.height = '2em';
			textarea.style.padding = '0';
			textarea.style.border = 'none';
			textarea.style.outline = 'none';
			textarea.style.boxShadow = 'none';
			textarea.style.background = 'transparent';
			textarea.style.opacity = '0';
			textarea.style.zIndex = '-1';

			// 设置 readonly 防止弹出键盘（重要！移动端必须）
			textarea.setAttribute('readonly', 'readonly');

			document.body.appendChild(textarea);

			// iOS 兼容处理
			if (this.isIOS) {
				const range = document.createRange();
				range.selectNodeContents(textarea);
				const selection = window.getSelection();
				selection.removeAllRanges();
				selection.addRange(range);
				textarea.setSelectionRange(0, text.length);
			} else {
				// Android 和其他设备
				textarea.select();
				textarea.setSelectionRange(0, text.length);
			}

			try {
				const successful = document.execCommand('copy');
				if (successful) {
					this.toast({
						message: '已复制',
						className: 'radius-toast'
					});
				} else {
					this.toast({
						message: '复制失败，请手动复制',
						className: 'radius-toast'
					});
				}
			} catch (err) {
				console.error('复制失败:', err);
				this.toast({
					message: '复制失败，请手动复制',
					className: 'radius-toast'
				});
			} finally {
				// 移除临时元素
				document.body.removeChild(textarea);
			}
		}
	}
}
</script>

<style>

.radius-toast {
	border-radius: 22pt;
	padding: 12pt 24pt !important;
}
</style>



// WEBPACK FOOTER //
// TransAccounts.vue?59900e94